// import api from '@/utils/api';

const state = {
    financialAnalysisItems: [],
};

const getters = {
    financialAnalysisItems: (state) => state.financialAnalysisItems,
};

const actions = {
    updateFinancialAnalysisItems({ commit }) {
        const options = [
            {
                value: '01',
                label: '資產',
                children: [
                    {
                        value: '0101',
                        label: '存款',
                    },
                    {
                        value: '0102',
                        label: '現金',
                    },
                ],
            },
            {
                value: '02',
                label: '流動收支',
                children: [
                    {
                        value: '0201',
                        label: '保證金',
                    },
                    {
                        value: '00203',
                        label: '預收帳款',
                    },
                    {
                        value: '00204',
                        label: '應收帳款',
                    },
                    {
                        value: '00205',
                        label: '抵押金',
                    },
                ],
            },
            {
                value: '03',
                label: '借款',
                children: [
                    {
                        value: '0301',
                        label: '銀行貸款',
                    },
                    {
                        value: '0302',
                        label: '其他信貸',
                    },
                ],
            },
            {
                value: '04',
                label: '互轉',
                children: [
                    {
                        value: '0401',
                        label: '台新-台銀',
                    },
                    {
                        value: '0402',
                        label: '華南-台新',
                    },
                ],
            },
        ];
        commit('update_financialAnalysisItems', options);
        /*
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetIncomeStatementSettings', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_statementOptions', resp.data);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
        */
    },
};

const mutations = {
    update_financialAnalysisItems(state, options) {
        state.financialAnalysisItems = options;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
